import { useQuery } from '@tanstack/react-query'
import { useAlert } from 'contexts/AlertContext'
import { FilesUrlResponse } from 'models/dtos'
import React from 'react'
import { currentQueryService } from 'utils/api/queries'

const useGetFilesUrls = (ids: Array<string>) => {
  const { displayAlert } = useAlert()
  const hasIds = ids.length > 0
  const result = useQuery<FilesUrlResponse, Error>({
    queryKey: ['useGetAuction', ids],
    queryFn: () => currentQueryService.getFilesStorageUrl(ids),
    enabled: hasIds,
  })

  const { isLoading, isError, isSuccess, error } = result

  React.useEffect(() => {
    if (isError) {
      displayAlert(error?.message || 'Erreur pendant la recupération des photos', 'error')
    }
  }, [error])

  const idsAndUrls = hasIds ? result.data?.urls || [] : []

  const filesUrls = hasIds ? result.data?.urls.map((link) => link.url) || [] : []

  return { idsAndUrls, filesUrls, isLoading, isError, isSuccess }
}

export { useGetFilesUrls }
